// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cPR75kdAXDGVxib0PszB {
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 3vmin;
  font-size: 2vmin;
  color: var(--text-light);
  height: 90%;
  overflow: scroll;
  background-color: var(--tan-1);
  border: 0.1vmin solid var(--tan-3);
  border-radius: 2vmin;
  margin: 3vmin 0;
  padding: 3vmin;
  margin-right: 2vmin;
}

.cPR75kdAXDGVxib0PszB .ap70fWT3eETsAtLlRQKl {
  width: 100%;
}

.cPR75kdAXDGVxib0PszB .vVkqXbRqxMYDCnUttflb {
  margin-top: 3vmin;
  justify-content: flex-start;
  height: calc(100vh - 18vmin);
  width: 100%;
}

.cPR75kdAXDGVxib0PszB .V5OAbv7QFHo6WglNx0m0 {
  width: 100%;
  display: grid;
  grid-template-columns: 18.35vw 5.75vw 1fr;
  padding: 1vmin 0;
  color: var(--text-light);
  border-top: 0.1vmin solid var(--tan-3);
}

.cPR75kdAXDGVxib0PszB .V5OAbv7QFHo6WglNx0m0 span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5vw;
  color: var(--text-dark);
}

.cPR75kdAXDGVxib0PszB .V5OAbv7QFHo6WglNx0m0 span.GtULiQQdndLNSQN4Yc97 {
  display: flex;
  justify-content: flex-start;
}

.cPR75kdAXDGVxib0PszB .V5OAbv7QFHo6WglNx0m0 span.XqcEfpZBcAB2sBQtEfsQ {
  display: flex;
  justify-content: flex-end;
}

.cPR75kdAXDGVxib0PszB .dyrUhYTujwEUiMzpjxWX {
  position: absolute;
  top: 50vh;
  font-size: 2vmin;
}

.Fe1ElNWf9e3JuYu_7Ueo {
  display: flex;
  justify-content: space-between;
}

.fnmEL0QehoJhnY5og6uX {
  color: var(--white);
  background-color: var(--yellow-1);
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  border: 0.1vmin solid var(--tan-2);
  border-radius: 0.5vmin;
  outline: none;
  cursor: pointer;
  padding: 0.4vmin 0.5vmin;
  transition: transform 0.3 ease;
}

.fnmEL0QehoJhnY5og6uX:hover {
  color: var(--yellow-1);
  background-color: var(--white);
  cursor: pointer;
  transform: scale(1.04);
}`, "",{"version":3,"sources":["webpack://./src/components/OrderDetail/OrderDetail.module.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,iBAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,yCAAA;EACA,gBAAA;EACA,wBAAA;EACA,sCAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,2BAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;AACJ;;AACA;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;AAEJ;;AACA;EACI,aAAA;EACA,8BAAA;AAEJ;;AACA;EACI,mBAAA;EACA,iCAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kCAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,8BAAA;AAEJ;;AACA;EACI,sBAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;AAEJ","sourcesContent":[".OrderDetail {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 3vmin;\n    font-size: 2vmin;\n    color: var(--text-light);\n    height: 90%;\n    overflow: scroll;\n    background-color: var(--tan-1);\n    border: .1vmin solid var(--tan-3);\n    border-radius: 2vmin;\n    margin: 3vmin 0;\n    padding: 3vmin;\n    margin-right: 2vmin;\n}\n\n.OrderDetail .sectionHeading {\n    width: 100%\n}\n\n.OrderDetail .lineItemContainer {\n    margin-top: 3vmin;\n    justify-content: flex-start;\n    height: calc(100vh - 18vmin);\n    width: 100%;\n}\n\n.OrderDetail .total {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 18.35vw 5.75vw 1fr;\n    padding: 1vmin 0;\n    color: var(--text-light);\n    border-top: .1vmin solid var(--tan-3);\n}\n\n.OrderDetail .total span {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.5vw;\n    color: var(--text-dark);\n}\n\n.OrderDetail .total span.right {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.OrderDetail .total span.end {\n    display: flex;\n    justify-content: flex-end;\n}\n.OrderDetail .hungry {\n    position: absolute;\n    top: 50vh;\n    font-size: 2vmin;\n}\n\n.container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.prevBtn {\n    color: var(--white);\n    background-color: var(--yellow-1);\n    font-weight: bold;\n    text-decoration: none;\n    text-align: center;\n    border: .1vmin solid var(--tan-2);\n    border-radius: .5vmin;\n    outline: none;\n    cursor: pointer;\n    padding: .4vmin .5vmin;\n    transition: transform 0.3 ease;\n}\n\n.prevBtn:hover {\n    color: var(--yellow-1);\n    background-color: var(--white);\n    cursor: pointer;\n    transform: scale(1.04);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"OrderDetail": `cPR75kdAXDGVxib0PszB`,
	"sectionHeading": `ap70fWT3eETsAtLlRQKl`,
	"lineItemContainer": `vVkqXbRqxMYDCnUttflb`,
	"total": `V5OAbv7QFHo6WglNx0m0`,
	"right": `GtULiQQdndLNSQN4Yc97`,
	"end": `XqcEfpZBcAB2sBQtEfsQ`,
	"hungry": `dyrUhYTujwEUiMzpjxWX`,
	"container": `Fe1ElNWf9e3JuYu_7Ueo`,
	"prevBtn": `fnmEL0QehoJhnY5og6uX`
};
export default ___CSS_LOADER_EXPORT___;
